<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-5">Programos TURTAS atnaujinimai</h1>

    <v-card class="zinuteDataContainerCard pa-0">
      <v-card-text class="zinuteDataContainer">
        <v-data-table
          :headers="filteredHeaders"
          hide-default-header
          :items="itemsList"
          :loading="loading"
          :search="search"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: 'Rodyti po:',
            itemsPerPageAllText: 'visi',
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :sort-by.sync="pagination.sort"
          :sort-desc.sync="pagination.sortDesc"
          :server-items-length="pagination.total"
          :items-per-page="pagination.pageSize"
          :page.sync="pagination.page"
          :hide-default-footer="hideFooter"
          @update:options="updatePagination"
        >
          <template #[`item.tekstas`]="{ item }">
            <v-row>
              <v-col cols="12" md="10">
                <h3 class="mt-2">
                  <el-busena v-if="item.naujas" busena="Naujas" color="green" />
                  {{ item.zin_pavadinimas }}
                </h3>
              </v-col>
              <v-col cols="12" md="2" class="text-left">
                <span class="zinuteData">{{ item.zin_galioja_nuo }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="10">
                <div v-html="item.zin_aprasymas" class="zinute-tekstas"></div>
              </v-col>
            </v-row>
          </template>
          <template slot="loading">
            Kraunasi...
          </template>
          <template slot="no-results">
            Duomenų nėra
          </template>
          <template slot="no-data">
            Pranešimų nėra
          </template>
          <template #[`footer.page-text`]="props">
            Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import math from '../../mixins/math'

export default {
  name: 'ZinuteList',
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      zinutes: [],
      search: null,
      itemsPerPageOptions: [20, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['zinuteAktyvi']),
    headers() {
      return [
        {
          text: 'Tekstas',
          align: 'start',
          value: 'tekstas',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.zinutes.map(item => {
        item.zin_aprasymas = item.zin_aprasymas
          ? item.zin_aprasymas.replaceAll(
              'href="downloadRinkmena(',
              'class="zinute-rinkmena" href="#" onclick="downloadRinkmena('
            )
          : null

        const find = item.zin_aprasymas.match(
          /<a(.[^<]*)downloadFoto\('(.[^<]+)<\/a>/gim
        )

        if (find) {
          const newReplace = find.map(function(val) {
            val = val.replace(
              /<a(.[^<]*)downloadFoto\('/i,
              `<img src="${process.env.VUE_APP_BASE_API}zinute-foto/`
            )
            val = val.replace(/\/content(.[^<]+)<\/a>$/i, '/content" />')
            return val
          })

          item.zin_aprasymas = find.reduce((acc, item, i) => {
            return acc.replace(item, newReplace[i])
          }, item.zin_aprasymas)
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    window.downloadRinkmena = this.downloadRinkmena.bind(this)
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      const data = {
        ...this.pagination,
      }

      this.$axios
        .post(`zinute/sarasas`, data)
        .then(res => {
          this.zinutes = res.data.zinutes
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.$store.dispatch('zinuteAktyvi', 0)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
          Array.from(
            document.querySelectorAll('a.zinute-rinkmena')
          ).forEach(link => link.removeAttribute('target'))
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    downloadRinkmena(zinuteID, bylaID, hash) {
      this.$axios
        .get(`zinute/${zinuteID}/${bylaID}/${hash}/content`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          const contentDisposition = res.headers['content-disposition']
          let fileName = 'rinkmena'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(
              /filename="(.+)"|filename=(.+)/
            )
            if (fileNameMatch[1]) {
              fileName = fileNameMatch[1]
            }
            if (fileNameMatch[2]) {
              fileName = fileNameMatch[2]
            }
          }
          this.openFile(res.data, fileName)
        })
        .catch(err => {
          const errData = JSON.parse(Buffer.from(err.data).toString('utf8'))
          window._VMA.$emit('DATA_ERROR', errData.message)
        })
    },
    openFile(fileData, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(fileName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
<style lang="scss">
.zinuteDataContainerCard {
  min-width: 800px;
}
.zinuteDataContainer {
  min-width: 800px;
  max-width: 1100px;
  min-height: 300px;
}
.zinuteData {
  font-size: 15px;
}
.zinute-tekstas {
  margin-bottom: 15px;
  p {
    font-size: 15px;
    margin: 0 0 3px 0;
    padding: 0;
  }
  img {
    max-width: 100%;
  }
  ol > li,
  ul > li {
    list-style-type: none;
  }
  li::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  ul > li::before {
    content: '\2022';
  }

  ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
    counter-increment: list-0;
  }
  ol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-1;
  }
  ol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-2;
  }
  ol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-3;
  }
  ol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-4;
  }
  ol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
    counter-increment: list-5;
  }
  ol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
    counter-increment: list-6;
  }
  ol li.ql-indent-7 {
    counter-reset: list-8 list-9;
    counter-increment: list-7;
  }
  ol li.ql-indent-8 {
    counter-reset: list-9;
    counter-increment: list-8;
  }
  ol li::before {
    content: counter(list-0, decimal) '. ';
  }
  ol li.ql-indent-1::before {
    content: counter(list-1, lower-alpha) '. ';
  }
  ol li.ql-indent-2::before {
    content: counter(list-2, lower-roman) '. ';
  }
  ol li.ql-indent-3::before {
    content: counter(list-3, decimal) '. ';
  }
  ol li.ql-indent-4::before {
    content: counter(list-4, lower-alpha) '. ';
  }
  ol li.ql-indent-5::before {
    content: counter(list-5, lower-roman) '. ';
  }
  ol li.ql-indent-6::before {
    content: counter(list-6, decimal) '. ';
  }
  ol li.ql-indent-7::before {
    content: counter(list-7, lower-alpha) '. ';
  }
  ol li.ql-indent-8::before {
    content: counter(list-8, lower-roman) '. ';
  }

  .ql-indent-1 {
    padding-left: 3em;
  }
  .ql-indent-2 {
    padding-left: 6em;
  }
  .ql-indent-3 {
    padding-left: 9em;
  }
  .ql-indent-4 {
    padding-left: 12em;
  }
  .ql-indent-5 {
    padding-left: 15em;
  }
  .ql-indent-6 {
    padding-left: 18em;
  }
  .ql-indent-7 {
    padding-left: 21em;
  }
  .ql-indent-8 {
    padding-left: 24em;
  }

  .ql-align-left {
    text-align: left;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-justify {
    text-align: justify;
  }
}
.zinute-nauja {
  color: #f00;
  font-weight: 400;
  font-size: 0.9rem;
}
</style>
